// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2MtQy","list":"PatternAutocomplete_list__1CBPZ"};